import Vue from 'vue'
import Vuex from 'vuex'
import user from '@/store/modules/User'
import createPersistedState from 'vuex-persistedstate'
import inventory from '@/store/modules/inventory'
import searchInventory from '@/store/modules/inventory/search'
import member from '@/store/modules/institute/member'
import storage from '@/store/modules/institute/storage'
import inputReason from '@/store/modules/common/InputReason'
import inputUsage from '@/store/modules/common/InputUsage'
import item from '@/store/modules/inventory/item'
import assignees from '@/store/modules/inventory/assignees'
import category from '@/store/modules/inventory/category'
import divide from '@/store/modules/inventory/divide'
import tag from '@/store/modules/inventory/tag'
import formInventory from '@/store/modules/inventory/formInventory'
import dashboard from '@/store/modules/dashboard'
import inventoryHistory from '@/store/modules/inventory/history'
import msds from '@/store/modules/safety/msds'
import inventoryDeleteDisposal from '@/store/modules/inventory/deleteDisposal'
import institutionInformation from '@/store/modules/institute/information'
import safety from '@/store/modules/safety/index'
import cargo from './modules/cargo'
import inventory2 from '@/store/modules/inventory2'
import globalFilter from './modules/globalFilter'
import cookies from 'vue-cookies'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

const store = new Vuex.Store({
	namespaced: true,
	modules: {
		user,
		inventory,
		member,
		storage,
		searchInventory,
		inputReason,
		inputUsage,
		item,
		assignees,
		category,
		divide,
		tag,
		formInventory,
		dashboard,
		inventoryHistory,
		msds,
		inventoryDeleteDisposal,
		institutionInformation,
		safety,
		cargo,
		inventory2,
		globalFilter,
	},
	getters: {
		instituteId: state => {
			let id = cookies.get('instituteId')
			return state.user?.institute?.id ? state.user?.institute?.id : id
		},
	},
	strict: debug,
	plugins: [
		createPersistedState({
			paths: [
				'user',
				'inputReason',
				'inputUsage',
				'item',
				'divide',
				'formInventory',
				'safety',
			],
		}),
	],
})

export default store
